/**
 * Ouvrir cet appareil posera-t-il une question au navigateur ? La réponse lue sans rien ouvrir, une seule
 * règle pour le micro tenu du live (`useMicGate`) et le guidage de la question (`permissionPrompt`) :
 *  - le micro déjà obtenu dans la page (`microphoneGrantedInPage`) : aucune question ;
 *  - sinon la règle du souvenir du test (`accessOf`) : `permissions.query`, et les noms des appareils
 *    seulement quand il ne répond pas.
 */
import { microphoneGrantedInPage } from "./microphoneGrant"
import { permissionState } from "./permissionState"
import { accessOf } from "./verifiedMemory"

export type AccessDevice = "microphone" | "camera"

const INPUT: Record<AccessDevice, MediaDeviceKind> = { microphone: "audioinput", camera: "videoinput" }

/** Les appareils branchés de cette sorte, tels que le navigateur les nomme ; aucun quand la liste ne se lit pas. */
async function inputsOf(device: AccessDevice): Promise<MediaDeviceInfo[]> {
    try {
        return (await navigator.mediaDevices.enumerateDevices()).filter((input) => input.kind === INPUT[device])
    } catch {
        return []
    }
}

/** L'accès à l'appareil est acquis : l'ouvrir ne posera aucune question. */
export async function deviceAccessReady(device: AccessDevice): Promise<boolean> {
    if (device === "microphone" && microphoneGrantedInPage()) return true
    const permission = (await permissionState(device)) as string | null
    return accessOf(permission, permission == null ? await inputsOf(device) : []) === "granted"
}
